(() => {
  const CARD_SELECTOR = 'li.snize-product';
  const SIZE_CLASS = 'loopi-snize-card-size';
  const SALE_CLASS = 'loopi-snize-card-sale';
  const PROMO_CLASS = 'loopi-snize-card-promo';

  const getPromoSettings = () => {
    const header = document.querySelector(
      '[data-loopi-collection-header]'
    );

    if (!header) {
      return {
        enabled: false,
        code: '',
        percentage: 0,
        background: ''
      };
    }

    return {
      enabled: header.dataset.cardPromoEnabled === 'true',
      code: String(
        header.dataset.cardPromoCode || ''
      ).trim(),
      percentage: Number(
        header.dataset.cardPromoPercentage || 0
      ),
      background:
        String(
          header.dataset.cardPromoBackground || ''
        ).trim() || 'var(--loopi-neo)'
    };
  };

  const getClassValue = (card, prefix) => {
    const matchingClass = Array.from(
      card.classList
    ).find((className) =>
      className.startsWith(prefix)
    );

    return matchingClass
      ? matchingClass.slice(prefix.length)
      : '';
  };

  const formatSize = (value, gender) => {
    if (!value) return '';

    var formattedSize = String(value)
      .trim()
      .replace(/-/g, ' ')
      .toUpperCase();

    switch(formattedSize) {
      case "UK 15":
        if (gender != "mens") {
          formattedSize = "UK 1.5";
        }
        break;
      case "UK 25":
        formattedSize = "UK 2.5";
        break;
      case "UK 35":
        formattedSize = "UK 3.5";
        break;
      case "UK 45":
        formattedSize = "UK 4.5";
        break;
      case "UK 55":
        formattedSize = "UK 5.5";
        break;
      case "UK 65":
        formattedSize = "UK 6.5";
        break;
      case "UK 75":
        formattedSize = "UK 7.5";
        break;
      case "UK 85":
        formattedSize = "UK 8.5";
        break;
      case "UK 95":
        formattedSize = "UK 9.5";
        break;
      case "UK 105":
        formattedSize = "UK 10.5";
        break;
      case "UK 115":
        formattedSize = "UK 11.5";
        break;
      case "UK 125":
        formattedSize = "UK 12.5";
        break;
      case "UK 135":
        formattedSize = "UK 13.5";
        break;
      case "UK 145":
        formattedSize = "UK 14.5";
        break;
      case "UK 155":
        formattedSize = "UK 15.5";
        break;
    }

    return formattedSize;
  };

  const getCurrentPriceText = (card) => {
    const priceElement = card.querySelector(
      '.snize-price-list .snize-price'
    );

    if (!priceElement) return '';

    const priceClone = priceElement.cloneNode(true);

    priceClone
      .querySelectorAll(
        '.snize-highlight-saving-text, .snize-save-price-wrapper'
      )
      .forEach((element) => element.remove());

    return String(
      priceClone.textContent || ''
    ).trim();
  };

  const parsePrice = (priceText) => {
    if (!priceText) return null;

    const numericValue = priceText
      .replace(/,/g, '')
      .replace(/[^\d.-]/g, '');

    const parsedValue =
      Number.parseFloat(numericValue);

    return Number.isFinite(parsedValue)
      ? parsedValue
      : null;
  };

  const getCurrencySymbol = (priceText) => {
    const symbolMatch = String(
      priceText || ''
    ).match(/[^\d\s.,-]+/);

    return symbolMatch
      ? symbolMatch[0]
      : '£';
  };

  const formatPromoPrice = (
    price,
    percentage,
    currencySymbol
  ) => {
    const rawDiscount =
      price * (percentage / 100);

    const roundedDiscount =
      Math.floor(rawDiscount * 100) / 100;

    const discountedPrice =
      price - roundedDiscount;

    return `${currencySymbol}${discountedPrice.toFixed(2)}`;
  };

  const addSizeBadge = (
    card,
    thumbnailWrapper
  ) => {
    if (
      card.querySelector(`.${SIZE_CLASS}`)
    ) {
      return;
    }

    const rawSize = getClassValue(
      card,
      'snize-product-tag-size-'
    );

    const rawGender = getClassValue(
      card,
      'snize-product-tag-gender-'
    );

    const size = formatSize(rawSize, rawGender);

    if (!size) return;

    const sizeElement =
      document.createElement('span');

    sizeElement.className = SIZE_CLASS;
    sizeElement.textContent = size;

    thumbnailWrapper.appendChild(
      sizeElement
    );
  };

  const addSaleBadge = (
    card,
    thumbnailWrapper
  ) => {
    if (
      card.querySelector(`.${SALE_CLASS}`)
    ) {
      return;
    }

    const isSale =
      card.querySelector(
        '.snize-price-with-discount'
      ) !== null ||
      card.querySelector(
        '.snize-discounted-price'
      ) !== null;

    if (!isSale) return;

    const saleElement =
      document.createElement('span');

    saleElement.className = SALE_CLASS;
    saleElement.textContent = 'Sale';

    thumbnailWrapper.appendChild(
      saleElement
    );
  };

  const addPromoPrice = (
    card,
    promoSettings
  ) => {
    if (!promoSettings.enabled) return;
    if (!promoSettings.code) return;

    if (
      promoSettings.percentage <= 0 ||
      promoSettings.percentage >= 100
    ) {
      return;
    }

    if (
      card.querySelector(`.${PROMO_CLASS}`)
    ) {
      card.classList.add(
        'loopi-snize-card--has-promo'
      );

      return;
    }

    const priceList = card.querySelector(
      '.snize-price-list'
    );

    if (!priceList) return;

    const currentPriceText =
      getCurrentPriceText(card);

    const currentPrice =
      parsePrice(currentPriceText);

    if (currentPrice === null) return;

    const currencySymbol =
      getCurrencySymbol(currentPriceText);

    const calculatedPrice =
      formatPromoPrice(
        currentPrice,
        promoSettings.percentage,
        currencySymbol
      );

    const promoElement =
      document.createElement('div');

    promoElement.className = PROMO_CLASS;

    promoElement.style.setProperty(
      '--loopi-card-promo-background',
      promoSettings.background
    );

    const priceElement =
      document.createElement('span');

    priceElement.className =
      `${PROMO_CLASS}__price`;

    priceElement.textContent =
      calculatedPrice;

    const copyElement =
      document.createElement('span');

    copyElement.className =
      `${PROMO_CLASS}__copy`;

    copyElement.textContent = 'with';

    const codeElement =
      document.createElement('strong');

    codeElement.className =
      `${PROMO_CLASS}__code`;

    codeElement.textContent =
      promoSettings.code;

    promoElement.appendChild(
      priceElement
    );

    promoElement.appendChild(
      copyElement
    );

    promoElement.appendChild(
      codeElement
    );

    priceList.insertAdjacentElement(
      'afterend',
      promoElement
    );

    card.classList.add(
      'loopi-snize-card--has-promo'
    );
  };

  const getElementOpacity = (
    element,
    fallback = '1'
  ) => {
    if (!element) return fallback;

    const computedOpacity =
      window.getComputedStyle(
        element
      ).opacity;

    return computedOpacity || fallback;
  };

  const syncInjectedOpacity = (card) => {
    const nativeImage =
      card.querySelector(
        '.snize-item-image'
      ) ||
      card.querySelector(
        '.snize-thumbnail'
      );

    const nativeContent =
      card.querySelector(
        '.snize-price-list'
      ) ||
      card.querySelector(
        '.snize-title'
      );

    const imageOpacity =
      getElementOpacity(nativeImage);

    const contentOpacity =
      getElementOpacity(nativeContent);

    const sizeBadge =
      card.querySelector(
        `.${SIZE_CLASS}`
      );

    const saleBadge =
      card.querySelector(
        `.${SALE_CLASS}`
      );

    const promoBar =
      card.querySelector(
        `.${PROMO_CLASS}`
      );

    if (sizeBadge) {
      sizeBadge.style.setProperty(
        'opacity',
        imageOpacity,
        'important'
      );
    }

    if (saleBadge) {
      saleBadge.style.setProperty(
        'opacity',
        imageOpacity,
        'important'
      );
    }

    if (promoBar) {
      promoBar.style.setProperty(
        'opacity',
        contentOpacity,
        'important'
      );
    }
  };

  const enhanceCard = (card) => {
    if (
      !(card instanceof HTMLElement)
    ) {
      return;
    }

    const thumbnailWrapper =
      card.querySelector(
        '.snize-thumbnail-wrapper'
      );

    if (thumbnailWrapper) {
      addSizeBadge(
        card,
        thumbnailWrapper
      );

      addSaleBadge(
        card,
        thumbnailWrapper
      );
    }

    addPromoPrice(
      card,
      getPromoSettings()
    );

    syncInjectedOpacity(card);
  };

  const enhanceAllCards = (
    root = document
  ) => {
    if (
      root instanceof Element &&
      root.matches(CARD_SELECTOR)
    ) {
      enhanceCard(root);
    }

    root
      .querySelectorAll?.(
        CARD_SELECTOR
      )
      .forEach(enhanceCard);
  };

  let scheduled = false;

  const scheduleEnhancement = () => {
    if (scheduled) return;

    scheduled = true;

    window.requestAnimationFrame(() => {
      enhanceAllCards();
      scheduled = false;
    });
  };

  const observer =
    new MutationObserver(() => {
      scheduleEnhancement();
    });

  const initialise = () => {
    enhanceAllCards();

    observer.observe(
      document.body,
      {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: [
          'class',
          'style',
          'checked',
          'aria-checked'
        ]
      }
    );

    document.addEventListener(
      'change',
      (event) => {
        if (
          event.target.matches?.(
            '.snize-product-filters-checkbox'
          )
        ) {
          scheduleEnhancement();

          window.setTimeout(
            scheduleEnhancement,
            100
          );

          window.setTimeout(
            scheduleEnhancement,
            400
          );
        }
      }
    );
  };

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initialise,
      { once: true }
    );
  } else {
    initialise();
  }
})();